import { Component, Output, EventEmitter } from "@angular/core";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import { VAIconRegistryService, redo } from "@va/core-library/icons";
import * as dayjs from "dayjs";

@Component({
  selector: "app-research-date-filter",
  templateUrl: "./research-date-filter.component.html",
  styleUrls: ["./research-date-filter.component.scss"],
})
export class ResearchDateFilterComponent {
  @Output() startDateSelected = new EventEmitter();
  @Output() endDateSelected = new EventEmitter();
  faRedo: any = faRedo;
  visible = false;
  radioValue = "";
  lblVal = "";
  startDate = "";
  endDate = "";
  customStartDate = null;
  customEndDate = null;
  lastAppliedFilterObject = {};
  popoverOpen = false;
  validDate = true;
  payload = { startDate: "", endDate: "" };
  options = [
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 30 Days", value: "oneMonth" },
    { label: "Last 3 Months", value: "threeMonths" },
    { label: "Last 6 Months", value: "sixMonths" },
    { label: "Last 12 Months", value: "twelveMonths" },
  ];
  // icons
  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([redo]);
  }
  optionSelected() {
    this.payload = { startDate: "", endDate: "" };
    switch (this.radioValue) {
      case "yesterday":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        this.endDate = this.startDate;
        this.payload = {
          startDate: this.startDate,
          endDate: this.endDate,
        };
        break;

      case "oneMonth":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(30, "day").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        this.payload = {
          startDate: this.startDate,
          endDate: this.endDate,
        };
        break;

      case "threeMonths":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(3, "month").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        this.payload = {
          startDate: this.startDate,
          endDate: this.endDate,
        };
        break;

      case "sixMonths":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(6, "month").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        this.payload = {
          startDate: this.startDate,
          endDate: this.endDate,
        };
        break;

      case "twelveMonths":
        this.validDate = true;
        this.customStartDate = null;
        this.customEndDate = null;
        this.startDate = dayjs().subtract(12, "month").format("YYYY-MM-DD");
        this.endDate = dayjs().format("YYYY-MM-DD");
        this.payload = {
          startDate: this.startDate,
          endDate: this.endDate,
        };
        break;

      case "choose":
        this.startDate = this.customStartDate || "";
        this.endDate = this.customEndDate || "";
        this.lblVal = `${dayjs(this.startDate).format("DD/MM/YYYY")} - ${dayjs(
          this.endDate,
        ).format("DD/MM/YYYY")}`;

        if (this.startDate !== "" && this.endDate !== "") {
          this.validDate = true;
          this.payload = {
            startDate: dayjs(this.startDate).format("YYYY-MM-DD"),
            endDate: dayjs(this.endDate).format("YYYY-MM-DD"),
          };
        } else {
          this.validDate = false;
        }
        break;

      default:
        this.startDate = "";
        this.endDate = "";
        this.payload = {
          startDate: this.startDate,
          endDate: this.endDate,
        };
    }
  }

  startDateChange(date: Date): void {
    this.customStartDate = date;
  }

  endDateChange(date: Date): void {
    this.customEndDate = date;
  }

  disabledStartDate = (startValue: Date): boolean => {
    if (!startValue || !this.customEndDate) {
      return false;
    }
    return startValue.getTime() > this.customEndDate.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    if (!endValue || !this.customStartDate) {
      return false;
    }
    return endValue.getTime() < this.customStartDate.getTime();
  };

  reset() {
    if (this.radioValue !== "") {
      this.radioValue = "";
      this.lblVal = "";
      this.optionSelected();
    }
    this.customStartDate = null;
    this.customEndDate = null;
    this.startDateSelected.emit(this.payload.startDate);
    this.endDateSelected.emit(this.payload.endDate);
  }

  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen === false && this.radioValue !== "") {
      //setting label value
      if (this.radioValue !== "choose") {
        const index = this.options.findIndex(
          (x) => x.value === this.radioValue,
        );
        this.lblVal = this.options[index].label;
      }
      this.optionSelected();
      this.startDateSelected.emit(this.payload.startDate);
      this.endDateSelected.emit(this.payload.endDate);
    }
  }
}
